<template lang="html">
  <div id="offers-page">

    <section class="main-section" data-aos="fade-in" data-aos-duration="1000">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">NUESTRAS OFERTAS</h2>
          </div>

          <div class="col-12 col-results">
            <div class="row">
              <div class="col-lg-6 box-article-s1" v-for="(a, aInx) in blog" :key="'aInx-'+aInx">
                <router-link class="box" to="/ofertas/1">
                  <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+a.imageUrl+')' }"></div>

                  <div class="box-info">
                    <h5 class="title">{{ a.title }}</h5>

                    <div class="b-text" v-html="a.text"></div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      blog: [
        { imageUrl: 'public/images/pages/blog/article-1.jpg',
          title: 'Nueva ruta conecta Guadalajara y Los Mochis',
          text: `
            En un esfuerzo por fortalecer las opciones de
            transporte y expandir las conexiones regionales, se ha
            anunciado la apertura de una nueva ruta que unirá la
            ciudad de Guadalajara, Jalisco, con Los Mochis,
            Sinaloa.<br />
            <br />
            Esta nueva conexión promete ser un importante
            impulso tanto para el turismo como para el comercio
            entre estas dos vibrantes ciudades.
          `
        },
        { imageUrl: 'public/images/pages/blog/article-2.jpg',
          title: 'Ahorra reservando con anticipación para la navidad',
          text: `
            Con la temporada navideña acercándose rápidamente,
            muchos están comenzando a planificar sus festividades
            y viajes.<br />
            <br />
            Este año, hacer tus reservas con anticipación puede
            ofrecer no solo tranquilidad sino también significativos
            ahorros económicos.
          `
        },
        { imageUrl: 'public/images/pages/blog/article-2.jpg',
          title: 'Ahorra reservando con anticipación para la navidad',
          text: `
            Con la temporada navideña acercándose rápidamente,
            muchos están comenzando a planificar sus festividades
            y viajes.<br />
            <br />
            Este año, hacer tus reservas con anticipación puede
            ofrecer no solo tranquilidad sino también significativos
            ahorros económicos.
          `
        },
        { imageUrl: 'public/images/pages/blog/article-1.jpg',
          title: 'Nueva ruta conecta Guadalajara y Los Mochis',
          text: `
            En un esfuerzo por fortalecer las opciones de
            transporte y expandir las conexiones regionales, se ha
            anunciado la apertura de una nueva ruta que unirá la
            ciudad de Guadalajara, Jalisco, con Los Mochis,
            Sinaloa.<br />
            <br />
            Esta nueva conexión promete ser un importante
            impulso tanto para el turismo como para el comercio
            entre estas dos vibrantes ciudades.
          `
        },
      ],
    }
  }
}
</script>
